import { EDIT_OPT_SETTING_SUCCESS, OPT_SETTING_FAILED, OPT_SETTING_LOADING, OPT_SETTING_SUCCESS } from "../actions/OPTSetting.action";
import { IOPTSetting, OPTSettingList } from "../models/OPTSetting.interface";

const initialState: OPTSettingList = {
    OPTLoading: true,
    OPTError: false,
    OPTMessage: "",
    OPTData: [],
}

const OPTSettingListReducer = (state: OPTSettingList = initialState, action: any): OPTSettingList => {
    switch (action.type) {
        case OPT_SETTING_LOADING:
            return {
                ...state,
                OPTLoading: true,
                OPTError: false
            }
        case OPT_SETTING_SUCCESS:
            const newData = action.payload.res.map((item: IOPTSetting) => {
                return { id: item.id, sender_id: item.sender_id, keywords: item.keywords, service: item.service, opt_confirmation: item.opt_confirmation, template_id: item.template_id, status: item.status, template: item.template, sender: item.sender }
            });
            return {
                ...state,
                OPTLoading: false,
                OPTError: false,
                OPTMessage: "",
                OPTData: newData
            }
            case EDIT_OPT_SETTING_SUCCESS:
                return {
                    ...state,
                    OPTLoading: false,
                    OPTError: false,
                    OPTMessage: ""
                }
        case OPT_SETTING_FAILED:
            return {
                ...state,
                OPTLoading: false,
                OPTError: true,
                OPTMessage: action.payload.error.message || ""
            }
        default:
            return state;
    }
}

export default OPTSettingListReducer;